// Update the container dataset type for the legend
export const updateContainerDataType = (type) => {
    const container = document.querySelector('.js-react-player-stats');

    if (container) {
        container.dataset.type = type.toLowerCase();
    }
};
